module.exports = __webpack_public_path__ + "img/icon1.fc5cd34b.png";